export function registerCustomBlocks(editor) {
  const bm = editor.BlockManager;

  // ==========================================
  // CATEGORY: BASIC ELEMENTS
  // ==========================================
  bm.add('basic-heading', {
    label: '<i class="fa-solid fa-heading" style="color: #6366f1; margin-bottom: 6px; font-size: 20px;"></i><br><span>Heading</span>',
    category: 'Basic Elements',
    content: '<h2 style="font-size: 32px; font-weight: 700; color: #1e293b; margin-bottom: 12px; font-family: Inter, sans-serif;">Your Section Heading</h2>',
  });

  bm.add('basic-text', {
    label: '<i class="fa-solid fa-font" style="color: #a855f7; margin-bottom: 6px; font-size: 20px;"></i><br><span>Paragraph</span>',
    category: 'Basic Elements',
    content: '<p style="font-size: 16px; color: #475569; line-height: 1.6; font-family: Inter, sans-serif;">Insert your custom paragraph text here. Double-click to edit inline.</p>',
  });

  bm.add('basic-button', {
    label: '<i class="fa-solid fa-square-poll-horizontal" style="color: #10b981; margin-bottom: 6px; font-size: 20px;"></i><br><span>Button</span>',
    category: 'Basic Elements',
    content: '<a href="#" style="display: inline-block; padding: 12px 28px; background: #6366f1; color: #ffffff; text-decoration: none; border-radius: 8px; font-weight: 600; font-family: Inter, sans-serif;">Click Here</a>',
  });

  bm.add('basic-image', {
    label: '<i class="fa-regular fa-image" style="color: #f59e0b; margin-bottom: 6px; font-size: 20px;"></i><br><span>Image</span>',
    category: 'Basic Elements',
    content: {
      type: 'image',
      style: { width: '100%', 'max-width': '600px', 'border-radius': '12px', display: 'block', margin: '15px auto' },
    },
  });

  bm.add('basic-video', {
    label: '<i class="fa-solid fa-circle-play" style="color: #ef4444; margin-bottom: 6px; font-size: 20px;"></i><br><span>Video</span>',
    category: 'Basic Elements',
    content: {
      type: 'video',
      src: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
      style: { width: '100%', height: '350px', 'border-radius': '12px' },
    },
  });

  bm.add('basic-divider', {
    label: '<i class="fa-solid fa-minus" style="color: #64748b; margin-bottom: 6px; font-size: 20px;"></i><br><span>Divider</span>',
    category: 'Basic Elements',
    content: '<hr style="border: 0; border-top: 1px solid #e2e8f0; margin: 30px 0;">',
  });

  // ==========================================
  // CATEGORY: LAYOUTS & COLUMNS
  // ==========================================
  bm.add('grid-1-col', {
    label: '<i class="fa-solid fa-square" style="color: #38bdf8; margin-bottom: 6px; font-size: 20px;"></i><br><span>1 Column</span>',
    category: 'Grids & Layouts',
    content: '<div style="padding: 24px; background: rgba(0,0,0,0.02); border: 1px dashed #cbd5e1; border-radius: 8px; min-height: 80px;">1 Column Container</div>',
  });

  bm.add('grid-2-col', {
    label: '<i class="fa-solid fa-table-columns" style="color: #38bdf8; margin-bottom: 6px; font-size: 20px;"></i><br><span>2 Columns</span>',
    category: 'Grids & Layouts',
    content: `
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; padding: 20px;">
        <div style="padding: 20px; background: rgba(0,0,0,0.02); border: 1px dashed #cbd5e1; border-radius: 8px; min-height: 80px;">Column 1</div>
        <div style="padding: 20px; background: rgba(0,0,0,0.02); border: 1px dashed #cbd5e1; border-radius: 8px; min-height: 80px;">Column 2</div>
      </div>
    `,
  });

  bm.add('grid-3-col', {
    label: '<i class="fa-solid fa-table-cells" style="color: #38bdf8; margin-bottom: 6px; font-size: 20px;"></i><br><span>3 Columns</span>',
    category: 'Grids & Layouts',
    content: `
      <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 20px; padding: 20px;">
        <div style="padding: 20px; background: rgba(0,0,0,0.02); border: 1px dashed #cbd5e1; border-radius: 8px; min-height: 80px;">Col 1</div>
        <div style="padding: 20px; background: rgba(0,0,0,0.02); border: 1px dashed #cbd5e1; border-radius: 8px; min-height: 80px;">Col 2</div>
        <div style="padding: 20px; background: rgba(0,0,0,0.02); border: 1px dashed #cbd5e1; border-radius: 8px; min-height: 80px;">Col 3</div>
      </div>
    `,
  });

  // ==========================================
  // CATEGORY: PRESET SECTIONS
  // ==========================================
  bm.add('hero-block', {
    label: '<i class="fa-solid fa-rocket" style="color: #818cf8; margin-bottom: 6px; font-size: 20px;"></i><br><span>Hero Section</span>',
    category: 'Preset Sections',
    content: `
      <section style="padding: 70px 20px; text-align: center; background: linear-gradient(135deg, #1e1b4b 0%, #312e81 100%); color: #ffffff; border-radius: 12px; font-family: Inter, sans-serif;">
        <span style="display:inline-block; padding: 6px 16px; background: rgba(255,255,255,0.15); border: 1px solid rgba(255,255,255,0.25); color: #c7d2fe; border-radius: 20px; font-size: 13px; font-weight: 600; margin-bottom: 20px;">EXCLUSIVE CAMPAIGN</span>
        <h1 style="font-size: 42px; font-weight: 800; margin-bottom: 16px; line-height: 1.2;">Elevate Your Market Strategy</h1>
        <p style="font-size: 17px; color: #cbd5e1; max-width: 650px; margin: 0 auto 30px; line-height: 1.6;">Access real-time institutional grade analytics, recommendations, and execution tools designed for serious traders.</p>
        <div>
          <a href="#" style="display: inline-block; padding: 14px 32px; background: #6366f1; color: #ffffff; text-decoration: none; border-radius: 8px; font-weight: 600; margin-right: 12px;">Get Started Now</a>
          <a href="#" style="display: inline-block; padding: 14px 32px; background: transparent; border: 1px solid rgba(255,255,255,0.4); color: #ffffff; text-decoration: none; border-radius: 8px; font-weight: 600;">Learn More</a>
        </div>
      </section>
    `,
  });

  bm.add('features-grid-block', {
    label: '<i class="fa-solid fa-border-all" style="color: #34d399; margin-bottom: 6px; font-size: 20px;"></i><br><span>Feature Cards</span>',
    category: 'Preset Sections',
    content: `
      <section style="padding: 50px 20px; background-color: #f8fafc; font-family: Inter, sans-serif; border-radius: 12px;">
        <div style="max-width: 1100px; margin: 0 auto; display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 24px;">
          
          <div style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 28px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);">
            <div style="width: 46px; height: 46px; background: #e0e7ff; color: #4338ca; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 22px; margin-bottom: 18px;">🚀</div>
            <h3 style="font-size: 19px; font-weight: 700; color: #0f172a; margin-bottom: 10px;">High Precision Calls</h3>
            <p style="font-size: 14px; color: #64748b; line-height: 1.6;">SEBI registered research analysis with verified track record and multi-target strategies.</p>
          </div>

          <div style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 28px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);">
            <div style="width: 46px; height: 46px; background: #dcfce7; color: #15803d; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 22px; margin-bottom: 18px;">⚡</div>
            <h3 style="font-size: 19px; font-weight: 700; color: #0f172a; margin-bottom: 10px;">Instant Alerts</h3>
            <p style="font-size: 14px; color: #64748b; line-height: 1.6;">Real-time push, SMS, and WhatsApp alerts ensure you never miss critical entry/exit points.</p>
          </div>

          <div style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 12px; padding: 28px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);">
            <div style="width: 46px; height: 46px; background: #f3e8ff; color: #7e22ce; border-radius: 10px; display: flex; align-items: center; justify-content: center; font-size: 22px; margin-bottom: 18px;">🛡️</div>
            <h3 style="font-size: 19px; font-weight: 700; color: #0f172a; margin-bottom: 10px;">Risk Managed</h3>
            <p style="font-size: 14px; color: #64748b; line-height: 1.6;">Strict risk-to-reward ratio calculated for every single trade setup to preserve capital.</p>
          </div>

        </div>
      </section>
    `,
  });

  bm.add('pricing-card-block', {
    label: '<i class="fa-solid fa-tags" style="color: #fbbf24; margin-bottom: 6px; font-size: 20px;"></i><br><span>Pricing Card</span>',
    category: 'Preset Sections',
    content: `
      <div style="max-width: 380px; margin: 30px auto; background: #ffffff; border: 2px solid #6366f1; border-radius: 16px; padding: 36px 28px; text-align: center; position: relative; font-family: Inter, sans-serif; box-shadow: 0 10px 25px -5px rgba(99, 102, 241, 0.15);">
        <span style="background: #6366f1; color: #fff; font-size: 12px; font-weight: 700; padding: 5px 16px; border-radius: 20px; position: absolute; top: -14px; left: 50%; transform: translateX(-50%); letter-spacing: 0.5px;">RECOMMENDED</span>
        <h3 style="font-size: 22px; font-weight: 700; color: #0f172a; margin-bottom: 8px;">Streetfolio Pro</h3>
        <p style="font-size: 14px; color: #64748b; margin-bottom: 20px;">Ideal for active equity & derivative investors</p>
        <div style="font-size: 42px; font-weight: 800; color: #0f172a; margin-bottom: 20px;">₹4,999<span style="font-size: 15px; color: #64748b; font-weight: normal;"> / quarter</span></div>
        <ul style="list-style: none; padding: 0; margin-bottom: 28px; text-align: left; font-size: 14px; color: #334155; line-height: 2.2;">
          <li>✓ All Premium Research Calls</li>
          <li>✓ Realtime WhatsApp & SMS Alerts</li>
          <li>✓ Dedicated Relationship Manager</li>
          <li>✓ Weekly Portfolio Rebalancing</li>
        </ul>
        <a href="#" style="display: block; padding: 14px; background: #6366f1; color: #fff; text-decoration: none; border-radius: 8px; font-weight: 600;">Subscribe Now</a>
      </div>
    `,
  });

  bm.add('testimonial-block', {
    label: '<i class="fa-solid fa-quote-left" style="color: #38bdf8; margin-bottom: 6px; font-size: 20px;"></i><br><span>Testimonial</span>',
    category: 'Preset Sections',
    content: `
      <div style="max-width: 700px; margin: 40px auto; background: #f8fafc; border-left: 4px solid #6366f1; padding: 28px 32px; border-radius: 0 12px 12px 0; font-family: Inter, sans-serif;">
        <p style="font-size: 17px; font-style: italic; color: #334155; margin-bottom: 18px; line-height: 1.6;">
          "The accuracy of the advisory calls and clear target/stoploss guidelines made my trading systematic and profitable."
        </p>
        <div style="display: flex; align-items: center; gap: 14px;">
          <div style="width: 44px; height: 44px; background: #6366f1; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: 700; color: #fff; font-size: 16px;">RS</div>
          <div>
            <div style="font-weight: 700; color: #0f172a; font-size: 15px;">Rahul Sharma</div>
            <div style="font-size: 13px; color: #64748b;">Active Subscriber (3+ Years)</div>
          </div>
        </div>
      </div>
    `,
  });

  // ==========================================
  // CATEGORY: FORMS
  // ==========================================
  bm.add('contact-form-block', {
    label: '<i class="fa-solid fa-paper-plane" style="color: #f472b6; margin-bottom: 6px; font-size: 20px;"></i><br><span>Contact Form</span>',
    category: 'Forms',
    content: `
      <form style="max-width: 520px; margin: 30px auto; background: #ffffff; padding: 32px; border-radius: 12px; border: 1px solid #e2e8f0; font-family: Inter, sans-serif; box-shadow: 0 4px 10px rgba(0,0,0,0.05);">
        <h3 style="color: #0f172a; font-size: 22px; font-weight: 700; margin-bottom: 20px; text-align: center;">Request a Callback</h3>
        
        <div style="margin-bottom: 16px;">
          <label style="display: block; color: #475569; font-size: 13px; font-weight: 600; margin-bottom: 6px;">Full Name</label>
          <input type="text" placeholder="Your name" style="width: 100%; padding: 10px 14px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 6px; color: #0f172a; outline: none;">
        </div>

        <div style="margin-bottom: 16px;">
          <label style="display: block; color: #475569; font-size: 13px; font-weight: 600; margin-bottom: 6px;">Mobile Number</label>
          <input type="tel" placeholder="+91 98765 43210" style="width: 100%; padding: 10px 14px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 6px; color: #0f172a; outline: none;">
        </div>

        <div style="margin-bottom: 22px;">
          <label style="display: block; color: #475569; font-size: 13px; font-weight: 600; margin-bottom: 6px;">Message / Query</label>
          <textarea rows="3" placeholder="Tell us how we can help you..." style="width: 100%; padding: 10px 14px; background: #f8fafc; border: 1px solid #cbd5e1; border-radius: 6px; color: #0f172a; outline: none; resize: vertical;"></textarea>
        </div>

        <button type="button" style="width: 100%; padding: 13px; background: #6366f1; border: none; border-radius: 6px; color: #fff; font-weight: 600; font-size: 15px; cursor: pointer;">Submit Request</button>
      </form>
    `,
  });
}
